import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

function Services() {
  const { id } = useParams(); // Get service ID from URL
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServiceDetails = async () => {
      try {
        const response = await fetch(`https://dhk.deliveryxpressbd.com/Services/s_details_api?id=${id}`);
        const data = await response.json();
        setService(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching service details:", error);
        setLoading(false);
      }
    };

    fetchServiceDetails();
  }, [id]);

  return (
    <>
      <Header />

      <div className="services_section layout_padding">

      <div class="container">
            <div class="row">
            {loading ? (
                  <p>Loading service details...</p>
                ) : service ? (
                  <>
               <div class="col-md-8">
                  <h1 class="services_taital">{service.name}</h1>
                  <p className="services_text" 
                      dangerouslySetInnerHTML={{ __html: service.description }}
                    ></p>
                  <div className="started_bt">
                        <a href="/contact">Contact Us</a>
                      </div>
               </div>
               <div class="col-md-4">
                  <h1 class="services_taital">
                     <div class="services_box">
                       
                        <div class="services_box_right">
                           
                           <div> {service && <img className="about_img" src={`${process.env.PUBLIC_URL}/Assets/images/Service/${service.image_path}`} alt={service.name} />}</div>
                        </div>
                     </div>
                    
                  </h1>
               </div>

               </>
                ) : (
                  <h1 class="services_taital">Services Details Not Found</h1>
                )}
            </div>
         </div>
        
      </div>

      <Footer />
    </>
  );
}

export default Services;
